import css from './AddCarScreen.module.css';
import autoPhoto from '../../assets/images/absentAutoImg.webp';
import flag from '../../assets/images/flagUa.webp';
import {
  BsFillCpuFill,
  BsFillCaretDownFill,
  BsCameraFill,
} from 'react-icons/bs';
import { IoMdClose } from 'react-icons/io';
import { IoMdCheckmark } from 'react-icons/io';
import { SlSpeedometer } from 'react-icons/sl';
import carList from '../../utils/brands_models_compiled.json';
import { useEffect, useRef, useState } from 'react';
import AddCarPopup from './AddCarPopup/AddCarPopup';
import clsx from 'clsx';
import { useDispatch, useSelector } from 'react-redux';
import {
  createNewCar,
  getAllCars,
  getCarInfoByPlateNumber,
  getMileageOrVinFromPhoto,
  getMileageOrVinFromPhotoResult,
  recognizeLicensePlate,
  updateCar,
} from '../../redux/cars/operations';
import {
  // selectCarId,
  selectCarInfo,
  selectCars,
  selectIsMileageOrVinLoading,
  selectIsRecognitionLoading,
  selectMileageOrVin,
  selectNewCar,
} from '../../redux/cars/selectors';
import LoaderSvg from '../Loader/LoaderSvg.jsx';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import {
  clearCarData,
  clearMileageOrVin,
  deleteCarInfo,
  deleteMileageOrVin,
  deleteNewCar,
} from '../../redux/cars/slice.js';
import { selectUser } from '../../redux/auth/selectors.js';
import { getBase64 } from '../../utils/getBase64.js';

export default function AddCarScreen() {
  const [chosenMake, setChosenMake] = useState({});
  const [chosenModel, setChosenModel] = useState({});
  const [makePopupOpen, setMakePopupOpen] = useState(false);
  const [modelPopupOpen, setModelPopupOpen] = useState(false);
  const [makeSearchQuery, setMakeSearchQuery] = useState('');
  const [modelSearchQuery, setModelSearchQuery] = useState('');
  const [displayedMakeArr, setDisplayedMakeArr] = useState([]);
  const [displayedModelArr, setDisplayedModelArr] = useState([]);
  const [yearPopupOpen, setYearPopupOpen] = useState(false);
  const [yearSearchQuery, setYearSearchQuery] = useState('');
  const [displayedYearArr, setDisplayedYearArr] = useState([]);
  const [chosenYear, setChosenYear] = useState('');
  const [mileage, setMileage] = useState('');
  const [vin, setVin] = useState('');
  const [plate, setPlate] = useState('');
  const [vinError, setVinError] = useState('');
  const dispatch = useDispatch();

  // console.log('mileage', mileage);
  // console.log('vin', vin);

  const buttonMakeRef = useRef(null);
  const buttonModelRef = useRef(null);
  const buttonYearRef = useRef(null);
  const videoRef = useRef(null);
  const modelInputRef = useRef(null);
  const makeInputRef = useRef(null);
  const yearInputRef = useRef(null);

  const carInfo = useSelector(selectCarInfo);
  const mileageOrVin = useSelector(selectMileageOrVin);
  const isRecognitionLoading = useSelector(selectIsRecognitionLoading);
  const isMileageOrVinLoading = useSelector(selectIsMileageOrVinLoading);
  const newCarInfo = useSelector(selectNewCar);
  // console.log('carInfo', carInfo);
  // console.log('newCarInfo', newCarInfo);

  const cars = useSelector(selectCars);
  const params = useParams();
  const carId = params?.carId;
  const userData = useSelector(selectUser);
  const mechanicId = userData?.id;

  const canvasRef = useRef(null);
  const [cameraOn, setCameraOn] = useState(false);
  const [cameraMileageOn, setCameraMileageOn] = useState(false);
  const [cameraVinOn, setCameraVinOn] = useState(false);
  const [videoStream, setVideoStream] = useState(null);
  const [photo, setPhoto] = useState(null);
  const [vinPhoto, setVinPhoto] = useState(null);
  const [mileagePhoto, setMileagePhoto] = useState(null);

  const originalDataRef = useRef({});

  const navigate = useNavigate();
  const location = useLocation();
  const addCarScreen = location.pathname === '/add-car';

  useEffect(() => {
    if (modelInputRef.current) {
      modelInputRef.current.focus();
    }
  }, [modelPopupOpen]);

  useEffect(() => {
    if (makeInputRef.current) {
      makeInputRef.current.focus();
    }
  }, [makePopupOpen]);

  useEffect(() => {
    if (yearInputRef.current) {
      yearInputRef.current.focus();
    }
  }, [yearPopupOpen]);

  const startCamera = async setCameraState => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: { facingMode: 'environment' },
      });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
      setVideoStream(stream);
      setCameraState(true);
    } catch (err) {
      console.error('Ошибка при доступе к камере', err);
    }
  };

  const stopCamera = () => {
    if (!cameraOn && !cameraMileageOn && !cameraVinOn) return;
    if (cameraOn) {
      setCameraOn(false);
    } else if (cameraMileageOn) {
      setCameraMileageOn(false);
    } else {
      setCameraVinOn(false);
    }
    setVideoStream(null);
    const tracks = videoRef.current?.srcObject?.getTracks();
    tracks?.forEach(track => track.stop());
  };

  const [loaderVinMileage, setLoaderVinMileage] = useState(false);

  const takePhoto = async (setPhotoState, type) => {
    const video = videoRef.current;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    ctx.drawImage(video, 0, 0);
    const dataUrl = canvas.toDataURL('image/jpeg');
    // setPhoto(dataUrl);
    setPhotoState(dataUrl);
    stopCamera();
    const base64Photo = dataUrl;
    if (type === 'photo') {
      return;
    } else if (type === 'mileage') {
      setLoaderVinMileage(true);
      dispatch(getMileageOrVinFromPhoto(base64Photo))
        .unwrap()
        .then(result => {
          updateVinMileageStatus(result?.task_id, type);
          // if (result.odometer !== null) {
          //   setMileage(result.odometer);
          // }
        })
        .catch(err => console.log('mileagePhotoErr', err));
    } else {
      setLoaderVinMileage(true);
      dispatch(getMileageOrVinFromPhoto(base64Photo))
        .unwrap()
        .then(result => {
          updateVinMileageStatus(result?.task_id, type);

          // if (result.vin !== null) {
          //   setVin(result.vin);
          // }
        })
        .catch(err => console.log('mileagePhotoErr', err));
    }
  };

  const updateVinMileageStatus = id => {
    dispatch(getMileageOrVinFromPhotoResult(id))
      .unwrap()
      .then(data => {
        if (data.status === 'completed') {
          if (data?.result?.type === 'mileage') {
            setMileage(Number(data?.result?.value));
            setLoaderVinMileage(false);
            toast.show({
              type: 'customSuccess',
              text1: 'Пробіг успішно розпізнано',
            });
          } else if (data?.result?.type === 'vin') {
            setVin(data.result?.value);
            setLoaderVinMileage(false);
            toast.show({
              type: 'customSuccess',
              text1: 'Vin-код успішно розпізнано',
            });
          }
          setLoaderVinMileage(false);
          //        setChosenParts(getLeaves(data?.filtered_tree?.nodes))
          //         setType("list")
          //         setVoiceAudio("")
          // setVoiceDiagLoader(false)
        } else if (data.status === 'processing' || data.status === 'pending') {
          // Якщо ще в процесі — чекаємо 2 секунди і питаємо знову
          setTimeout(() => updateVinMileageStatus(id), 5000);
        } else {
          setLoaderVinMileage(false);
          throw new Error('Помилка обробки на сервері');
        }
      });
  };

  const handleClick = (setPhotoState, cameraState, setCameraState, type) => {
    if (!cameraState) {
      startCamera(setCameraState);
    } else {
      takePhoto(setPhotoState, type);
    }
  };

  const handleCameraBtnClick = () => {
    if (cameraVinOn) {
      handleClick(setVinPhoto, cameraVinOn, setCameraVinOn, 'vin');
    } else if (cameraMileageOn) {
      handleClick(
        setMileagePhoto,
        cameraMileageOn,
        setCameraMileageOn,
        'mileage'
      );
    } else {
      if (addCarScreen) {
        setPlate('');
      }
      handleClick(setPhoto, cameraOn, setCameraOn, 'photo');
    }
  };

  const car = cars?.find(car => Number(car?.vehicle?.id) === Number(carId));
  const chosenCar = localStorage.getItem('chosenCar');
  const displayedCar = car ? car : JSON.parse(chosenCar);
  console.log('displayedCar', displayedCar);

  useEffect(() => {
    if (Object.keys(newCarInfo).length !== 0 && carId) {
      const existedMake = carList?.find(
        car => car?.name?.toLowerCase() === newCarInfo?.make.toLowerCase()
      );

      const existedModel = existedMake?.models?.find(
        model => model?.name?.toLowerCase() === newCarInfo?.model?.toLowerCase()
      );

      const existedPhoto = newCarInfo?.photo_url;

      setChosenMake({
        id: existedMake?.brand_id,
        make: existedMake?.name || newCarInfo?.make || '',
      });
      setChosenModel({
        id: existedModel?.model_id,
        model_name: existedModel?.name || newCarInfo?.model || '',
      });

      setChosenYear(newCarInfo?.year);
      setMileage(Number(newCarInfo?.mileage));
      setPlate(newCarInfo?.license_plate);
      setVin(newCarInfo?.vin);
      setPhoto(existedPhoto);

      originalDataRef.current = {
        carMake: newCarInfo?.make,
        carModel: newCarInfo?.model,
        carYear: newCarInfo?.year,
        carMileage: Number(newCarInfo?.mileage),
        carPlate: newCarInfo?.license_plate,
        carVin: newCarInfo?.vin,
        carPhoto: existedPhoto,
      };
    } else if (!carId || cars?.length === 0) return;
    else if (Object.keys(newCarInfo).length === 0 && carId) {
      const existedMake = carList?.find(
        car =>
          car?.name?.toLowerCase() ===
          displayedCar?.vehicle?.make?.toLowerCase()
      );

      const existedModel = existedMake?.models?.find(
        model =>
          model?.name?.toLowerCase() ===
          displayedCar?.vehicle?.model?.toLowerCase()
      );

      const existedPhoto = displayedCar?.photo_url;

      setChosenMake({
        id: existedMake?.brand_id,
        make: existedMake?.name || displayedCar?.vehicle?.make || '',
      });

      setChosenModel({
        id: existedModel?.model_id || '',
        model_name: existedModel?.name || displayedCar?.vehicle?.model || '',
      });

      setChosenYear(displayedCar?.vehicle?.year);
      setMileage(Number(displayedCar?.vehicle?.mileage));
      setPlate(displayedCar?.vehicle?.plate);
      setVin(displayedCar?.vehicle?.vin);
      setPhoto(existedPhoto);

      originalDataRef.current = {
        carMake: existedMake?.make || displayedCar?.vehicle?.make,
        carModel: existedModel?.name || displayedCar?.vehicle?.model,
        carYear: displayedCar?.vehicle?.year,
        carMileage: Number(displayedCar?.vehicle?.mileage),
        carPlate: displayedCar?.vehicle?.plate,
        carVin: displayedCar?.vehicle?.vin,
        carPhoto: existedPhoto,
      };
    }
  }, [carId, newCarInfo]);

  const formatModelName = (make, model) => {
    if (!make && !model) return 'Марку не визначено';

    if (!make) return model;
    if (!model) return make;

    // Нормалізуємо пробіли і регістр
    const normalizedMake = make.replace(/\s+/g, ' ').trim().toUpperCase();
    const normalizedModel = model.replace(/\s+/g, ' ').trim().toUpperCase();

    // Якщо make містить весь model — видаляємо model з make
    if (normalizedMake.includes(normalizedModel)) {
      const cleanedMake = normalizedMake
        .replace(normalizedModel, '')
        .replace(/\s+/g, ' ')
        .trim();

      return {
        make: cleanedMake,
        model: model.trim(),
      };
    }

    // Інакше повертаємо як є
    return {
      make: make.trim(),
      model: model.trim(),
    };
  };

  useEffect(() => {
    if (!carInfo || Object.keys(carInfo).length === 0) return;

    setPlate(carInfo?.plate);
    setChosenYear(carInfo?.year);
    setVin(carInfo?.vin || null);
    setMileage(carInfo?.mileage ? carInfo?.mileage : mileage ? mileage : '');

    const formattedMake = formatModelName(carInfo?.make, carInfo?.model);
    console.log('formattedMake', formattedMake);

    const existedMake = carList?.find(
      car => car?.name?.toLowerCase() === formattedMake?.make?.toLowerCase()
    );
    setChosenMake({ id: existedMake?.brand_id, make: existedMake?.name || '' });

    const existedModel = existedMake?.models?.find(
      model => model?.name?.toLowerCase() === carInfo?.model?.toLowerCase()
    );
    setChosenModel(
      existedModel
        ? {
            id: existedModel?.model_id,
            model_name: existedModel?.name || '',
          }
        : { model_name: carInfo?.model }
    );
  }, [carInfo]);

  const makeInputClick = e => {
    e.stopPropagation();
    setMakePopupOpen(!makePopupOpen);
    setMakeSearchQuery('');
    setChosenModel({});
    setChosenYear('');
  };

  const modelInputClick = e => {
    e.stopPropagation();
    setModelPopupOpen(!modelPopupOpen);
    setModelSearchQuery('');
  };

  const yearInputClick = e => {
    e.stopPropagation();
    setYearPopupOpen(!yearPopupOpen);
    setYearSearchQuery('');
  };

  const carMakesArr = carList?.map(car => ({
    id: car.brand_id,
    make: car.name,
  }));

  useEffect(() => {
    setDisplayedMakeArr(
      makeSearchQuery.trim() === ''
        ? carMakesArr
        : carMakesArr?.filter(car =>
            car.make
              .toString()
              .toLowerCase()
              .includes(makeSearchQuery.trim().toLowerCase())
          )
    );
  }, [makeSearchQuery]);

  useEffect(() => {
    if (!chosenMake?.make) {
      return;
    }
    const existedMake = carList?.find(
      item => Number(item.brand_id) === Number(chosenMake?.id)
    );

    const carModelsArr = existedMake?.models?.map(car => ({
      id: car.model_id,
      model_name: car.name,
    }));

    setDisplayedModelArr(
      modelSearchQuery.trim() === ''
        ? carModelsArr
        : carModelsArr?.filter(car =>
            car?.model_name
              .toString()
              .toLowerCase()
              .includes(modelSearchQuery.trim().toLowerCase())
          )
    );
  }, [chosenMake, modelSearchQuery]);

  useEffect(() => {
    if (!chosenMake?.make || !chosenModel?.model_name) {
      return;
    }

    const existedMake = carList?.find(
      item => Number(item.brand_id) === Number(chosenMake?.id)
    );
    const selectedCarModel = existedMake?.models.find(
      car => chosenModel?.model_name?.toLowerCase() === car.name.toLowerCase()
    );

    const yearArr = [];
    for (
      let i = selectedCarModel?.start_year;
      i <= selectedCarModel?.end_year;
      i++
    ) {
      yearArr.push(i);
    }

    setDisplayedYearArr(
      yearSearchQuery.trim() === ''
        ? yearArr
        : yearArr?.filter(year =>
            year
              .toString()
              .toLowerCase()
              .includes(yearSearchQuery.trim().toLowerCase())
          )
    );
  }, [chosenModel, yearSearchQuery, chosenMake]);

  useEffect(() => {
    if (videoRef.current && videoStream) {
      videoRef.current.srcObject = videoStream;
    }
  }, [videoStream]);

  const handleSend = async () => {
    // console.log('photo1', photo);

    if (!photo) {
      return;
    }

    // console.log('photo2', photo);

    // const dataURLtoBlob = dataUrl => {
    //   const arr = dataUrl.split(',');
    //   const mime = arr[0].match(/:(.*?);/)[1];
    //   const bstr = atob(arr[1]);
    //   let n = bstr.length;
    //   const u8arr = new Uint8Array(n);
    //   while (n--) u8arr[n] = bstr.charCodeAt(n);
    //   return new Blob([u8arr], { type: mime });
    // };

    const photoToSend = await getBase64(photo);
    // console.log('photoToSend', photoToSend);

    dispatch(recognizeLicensePlate(photoToSend))
      .unwrap()
      .then(res => {
        if (res?.car_info?.in_progress) {
          toast.error(
            `Авто ${
              res?.car_info?.record_service?.status === 'diagnostic'
                ? 'на діагностиці'
                : 'в ремонті'
            }`
          );
          navigate('/main');
          dispatch(clearCarData());
          dispatch(clearMileageOrVin());
          return;
        } else {
          res.error ? toast.error(res.error) : toast.success('Авто розпізнано');
        }
      });
  };

  const handleCheckPlate = () => {
    dispatch(getCarInfoByPlateNumber(plate.split(' ').join('')))
      .unwrap()
      .then(res => {
        if (res.in_progress) {
          toast.error(
            `Авто ${
              res?.record_service?.status === 'diagnostic'
                ? 'на діагностиці'
                : 'в ремонті'
            }`
          );
          navigate('/main');
          dispatch(clearCarData());
          dispatch(clearMileageOrVin());
        } else {
          toast.success('Авто розпізнано');
        }
      })
      .catch(error => {
        // Перевіряємо статус (наприклад, 404 Not Found)
        if (error?.status === 404) {
          toast.error('Автомобіль не знайдено в базі');
        } else {
          toast.error(error?.detail || 'Щось сталось, спробуйте ще раз');
        }
      });
  };

  const onCheckmarkBtnClick = () => {
    if (
      !chosenMake?.make ||
      !chosenModel?.model_name ||
      !plate ||
      !chosenYear ||
      !mileage ||
      !vin
    )
      return;

    if (carId) {
      const hasChanges =
        chosenMake?.make !== originalDataRef.current.carMake ||
        chosenModel?.model_name !== originalDataRef.current.carModel ||
        plate !== originalDataRef.current.carPlate ||
        vin !== originalDataRef.current.carVin ||
        chosenYear !== originalDataRef.current.carYear ||
        mileage !== originalDataRef.current.carMileage ||
        photo !== originalDataRef.current.carPhoto;

      console.log('hasChanges', hasChanges);
      console.log('originalDataRef', originalDataRef);

      if (!hasChanges) {
        navigate(`/car/${carId}/photos`);
      } else {
        const carData = {
          car_id: carId,
          plate,
          vin,
          year: Number(chosenYear),
          make: chosenMake?.make,
          model: chosenModel?.model_name,
          ...(photo !== originalDataRef.current.carPhoto && { photo: photo }),
          mileage: Number(mileage),
        };

        console.log('carDataWithId', carData);

        dispatch(updateCar(carData))
          .unwrap()
          .then(() => {
            toast.success('Інформація про авто успішно оновлена', {
              position: 'top-center',
              duration: 3000,
              style: {
                background: 'var(--bg-input)',
                color: 'var(--white)FFF',
              },
            });
            navigate(`/car/${carId}/photos`);
          })
          .catch(err => {
            console.log(err);

            toast.error('Щось сталося, спробуйте ще раз', {
              position: 'top-center',
              style: {
                background: 'var(--bg-input)',
                color: 'var(--white)FFF',
              },
            });
          });
      }
    } else {
      const carData = {
        license_plate: plate,
        make: chosenMake?.make,
        model: chosenModel?.model_name,
        year: Number(chosenYear),
        color: carInfo?.color ? carInfo?.color : '',
        capacity: carInfo?.capacity ? String(carInfo?.capacity) : '',
        vin: vin,
        mileage: Number(mileage),
        photo: photo,
      };

      console.log('carDataWithoutId', carData);

      dispatch(createNewCar(carData))
        .unwrap()
        .then(result => {
          console.log('result', result);

          if (
            result.message ===
            'Авто з таким номером уже існує в процесі обробки.'
          ) {
            toast.error('Авто з таким номером вже існує', {
              position: 'top-center',
              duration: 5000,
              style: {
                background: 'var(--bg-input)',
                color: 'var(--white)FFF',
              },
            });
          }
          if (result.id) {
            toast.success('Авто успішно створене', {
              position: 'top-center',
              duration: 5000,
              style: {
                background: 'var(--bg-input)',
                color: 'var(--white)FFF',
              },
            });
            dispatch(
              getAllCars({
                target_date: new Date().toLocaleString('sv').split(' ')[0],
                mechanic_id: mechanicId,
                // mechanic_id: 1,
              })
            );
            dispatch(deleteCarInfo());
            navigate(`/car/${result.id}/photos`);
          } else {
            console.error('ID не знайдено:', result);
          }
        })
        .catch(err => {
          console.log(err);

          toast.error('Щось сталося, спробуйте ще раз', {
            position: 'top-center',
            style: {
              background: 'var(--bg-input)',
              color: 'var(--white)FFF',
            },
          });
        });
    }
  };

  const onCloseBtnClick = () => {
    dispatch(deleteCarInfo());
    dispatch(deleteNewCar());
    dispatch(deleteMileageOrVin());
    navigate(`/main`);
  };

  const validate = val => {
    const onlyLatinAndDigits = /^[A-Za-z0-9]*$/;

    if (!onlyLatinAndDigits.test(val)) {
      setVinError('VIN може містити лише латинські букви та цифри');
    } else if (val.length > 17) {
      setVinError('VIN має містити 17 символів');
    } else if (val.length === 17) {
      // Якщо символи окей, але довжина рівно 17 — тоді перевіряємо формат
      const fullVinRegex = /^[A-Za-z0-9]{17}$/;
      if (!fullVinRegex.test(val)) {
        setVinError('VIN має містити 17 символів');
      } else {
        setVinError('');
      }
    } else {
      // Символи валідні, але ще не введено 17 — не показуємо помилку
      setVinError('');
    }
  };

  return isRecognitionLoading || loaderVinMileage ? (
    <LoaderSvg />
  ) : (
    <>
      <div className={`${css.wrapper} ${videoStream ? css.cameraOn : ''}`}>
        {(cameraOn || cameraMileageOn || cameraVinOn) && (
          <video ref={videoRef} autoPlay playsInline className={css.video} />
        )}

        {!cameraOn && !cameraMileageOn && !cameraVinOn && (
          <>
            <div className={css.carPhotoAndNumberWrapper}>
              <div className={css.carPhoto}>
                {photo ? (
                  <img
                    src={photo}
                    alt="car photo"
                    className={css.carImg}
                    onError={e => {
                      e.target.onerror = null;
                      e.target.src = autoPhoto;
                    }}
                  />
                ) : (
                  <img
                    src={autoPhoto || autoPhoto}
                    alt="car photo"
                    className={css.carImg}
                    onError={e => {
                      e.target.onerror = null;
                      e.target.src = autoPhoto;
                    }}
                  />
                )}
              </div>

              <div
                className={`${css.topWrapper} ${
                  !addCarScreen && css.topWrapperWithoutButton
                }`}
              >
                <div className={css.carNumberWrapper}>
                  <div className={css.numberWrapper}>
                    <img src={flag} alt="flag image" />
                    <p className={css.flagText}>UA</p>
                  </div>
                  <input
                    className={css.number}
                    type="text"
                    value={plate?.split(' ').join('')}
                    onChange={e => setPlate(e.target.value)}
                    placeholder="BA1234BA"
                  />
                </div>
                {addCarScreen ? (
                  <button
                    type="button"
                    className={css.btn}
                    onClick={() => {
                      if (plate) {
                        handleCheckPlate();
                      } else if (photo) {
                        handleSend();
                      }
                    }}
                    disabled={!photo && plate?.split('').length < 4}
                  >
                    <BsFillCpuFill className={css.btnIcon} />
                    {` Розпізнати ${
                      plate?.split('').length >= 4
                        ? 'номер'
                        : photo
                          ? 'фото'
                          : ''
                    }`}
                  </button>
                ) : (
                  ''
                )}
              </div>
            </div>
            <div className={css.bottomWrapper}>
              <div
                onClick={makeInputClick}
                ref={buttonMakeRef}
                className={css.inputWithPopup}
              >
                <div className={css.inputWrapper} onClick={makeInputClick}>
                  {makePopupOpen ? (
                    <input
                      type="text"
                      value={makeSearchQuery}
                      onChange={e => setMakeSearchQuery(e.target.value)}
                      className={`${css.input} ${css.text} ${css.textColor}`}
                      onClick={e => e.stopPropagation()}
                      placeholder="Марка авто"
                      ref={makeInputRef}
                    />
                  ) : (
                    <p
                      className={clsx(
                        css.text,
                        chosenMake?.make ? css.textColor : css.placeholderColor
                      )}
                    >
                      {chosenMake?.make || 'Марка авто'}
                    </p>
                  )}
                  <button
                    type="button"
                    className={css.arrow}
                    onClick={makeInputClick}
                  >
                    <BsFillCaretDownFill
                      className={clsx(
                        css.arrowIcon,
                        makePopupOpen && css.arrowIconOpen
                      )}
                    />
                  </button>
                </div>

                {makePopupOpen && (
                  <AddCarPopup
                    arr={displayedMakeArr}
                    fieldKey="make"
                    setFieldValue={setChosenMake}
                    buttonRef={buttonMakeRef}
                    onClose={() => setMakePopupOpen(false)}
                    isOpen={makePopupOpen}
                  />
                )}
              </div>
              <div
                onClick={modelInputClick}
                ref={buttonModelRef}
                className={css.inputWithPopup}
              >
                <div className={css.inputWrapper} onClick={modelInputClick}>
                  {modelPopupOpen ? (
                    <input
                      type="text"
                      value={modelSearchQuery}
                      onChange={e => setModelSearchQuery(e.target.value)}
                      className={`${css.input} ${css.text} ${css.textColor}`}
                      onClick={e => e.stopPropagation()}
                      placeholder="Модель авто"
                      ref={modelInputRef}
                    />
                  ) : (
                    <p
                      className={clsx(
                        css.text,
                        chosenModel?.model_name
                          ? css.textColor
                          : css.placeholderColor
                      )}
                    >
                      {chosenModel?.model_name || 'Модель авто'}
                    </p>
                  )}
                  <button
                    type="button"
                    className={css.arrow}
                    onClick={modelInputClick}
                  >
                    <BsFillCaretDownFill
                      className={clsx(
                        css.arrowIcon,
                        modelPopupOpen && css.arrowIconOpen
                      )}
                    />
                  </button>
                </div>
                {modelPopupOpen && (
                  <AddCarPopup
                    arr={displayedModelArr}
                    fieldKey="model_name"
                    setFieldValue={setChosenModel}
                    buttonRef={buttonModelRef}
                    onClose={() => setModelPopupOpen(false)}
                    isOpen={modelPopupOpen}
                  />
                )}
              </div>
              <div
                onClick={yearInputClick}
                ref={buttonYearRef}
                className={css.inputWithPopup}
              >
                <div className={css.inputWrapper} onClick={yearInputClick}>
                  {yearPopupOpen ? (
                    <input
                      type="text"
                      value={yearSearchQuery}
                      onChange={e => setYearSearchQuery(e.target.value)}
                      className={`${css.input} ${css.text} ${css.textColor}`}
                      onClick={e => e.stopPropagation()}
                      placeholder="Рік випуску"
                      ref={yearInputRef}
                    />
                  ) : (
                    <p
                      className={clsx(
                        css.text,
                        chosenYear ? css.textColor : css.placeholderColor
                      )}
                    >
                      {chosenYear || 'Рік випуску'}
                    </p>
                  )}
                  <button
                    type="button"
                    className={css.arrow}
                    onClick={yearInputClick}
                  >
                    <BsFillCaretDownFill
                      className={clsx(
                        css.arrowIcon,
                        yearPopupOpen && css.arrowIconOpen
                      )}
                    />
                  </button>
                </div>

                {yearPopupOpen && (
                  <AddCarPopup
                    arr={displayedYearArr}
                    setFieldValue={setChosenYear}
                    buttonRef={buttonYearRef}
                    onClose={() => setYearPopupOpen(false)}
                    isOpen={yearPopupOpen}
                  />
                )}
              </div>
              <div className={css.mileageWrapper}>
                <SlSpeedometer className={css.mileageIcon} />
                <input
                  className={css.mileage}
                  type="text"
                  value={mileage}
                  onChange={e => {
                    setMileage(e.target.value);
                  }}
                  placeholder="123000"
                />

                <p className={css.mileageText}>км</p>

                <BsCameraFill
                  className={css.cameraVinIcon}
                  onClick={() => startCamera(setCameraMileageOn)}
                />
              </div>
              <div className={`${css.mileageWrapper} ${css.vinWrapper}`}>
                <input
                  className={css.mileage}
                  type="text"
                  value={vin}
                  onChange={e => {
                    setVin(e.target.value);
                    validate(e.target.value);
                  }}
                  placeholder="vin"
                />
                <BsCameraFill
                  className={css.cameraVinIcon}
                  onClick={() =>
                    // handleClick(setVinPhoto, cameraVinOn, setCameraVinOn, 'vin')
                    startCamera(setCameraVinOn)
                  }
                />
                {vinError && <p className={css.error}>{vinError}</p>}
              </div>
            </div>
          </>
        )}
      </div>
      <div className={`${css.btnsWrapper} ${cameraOn ? css.isCameraOn : ''}`}>
        {!cameraOn && !cameraMileageOn && !cameraVinOn ? (
          <IoMdClose
            className={`${css.cancelBtn} ${css.cross}`}
            onClick={onCloseBtnClick}
          />
        ) : (
          <button className={css.cancelBtn} onClick={stopCamera}>
            <IoMdClose className={`${css.cancelBtn} ${css.cross}`} />
          </button>
        )}

        <div>
          <canvas ref={canvasRef} style={{ display: 'none' }} />
          {/* {!cameraMileageOn && !cameraVinOn && ( */}
          <button
            type="button"
            className={css.cameraBtn}
            onClick={handleCameraBtnClick}
          >
            <BsCameraFill className={css.cameraIcon} />
          </button>
          {/* // )} */}
        </div>
        {!cameraOn &&
        !cameraMileageOn &&
        chosenMake?.make &&
        chosenModel?.model_name &&
        chosenYear &&
        mileage &&
        vin &&
        !vinError &&
        plate ? (
          <IoMdCheckmark
            className={`${css.acceptBtn} ${css.check}`}
            onClick={onCheckmarkBtnClick}
          />
        ) : (
          <div className={css.emptyDiv}></div>
        )}
      </div>
    </>
  );
}
